<template>
  <div>
    <div class="card">
      <section>
        <div style="width: 20%">
          <div
            v-if="ownerItem.showPath != null"
            style="
              width: 75px;
              height: 75px;
              text-align: center;
              line-height: 75px;
              border-radius: 75px;
            "
          >
            <img
              style="width: 75px; height: 75px; border-radius: 75px"
              :src="ownerItem.showPath"
            />
          </div>

          <div
            style="
              color: white;
              background-color: #373737;
              width: 75px;
              height: 75px;
              text-align: center;
              line-height: 75px;
              border-radius: 75px;
            "
            v-else
          >
            暂无
          </div>
        </div>
        <div
          style="
            color: #6f6f6f;
            font-size: 20px;
            font-weight: bold;
            font-weight: bold;
            width: 60%;
            padding: 10px 20px 0 20px;
            height: 70px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          "
        >
          {{ ownerItem.abbreviation }}
        </div>
        <div style="width: 20%; text-align: center; font-size: 14px">
          <!-- <div @click.stop="goGl(ownerItem.deptId)" style="border: 1px solid #999;border-radius: 5px;padding: 3px;">管理员</div> -->
          <div
            @click.stop="goRc(ownerItem.abbreviation)"
            style="
              border: 1px solid #999;
              margin: 5px 0;
              border-radius: 5px;
              padding: 3px;
            "
          >
            人才
          </div>
          <div
            @click.stop="goHt(ownerItem.abbreviation)"
            style="border: 1px solid #999; border-radius: 5px; padding: 3px"
          >
            合同
          </div>
        </div>
      </section>
      <div class="bottom">
        <ul>
          <li>
            <p>公寓{{ ownerItem.sum }}</p>
          </li>
          <li>
            <p>已入住{{ ownerItem.checkIn }}</p>
          </li>
          <li>
            <p>未入住{{ ownerItem.free }}</p>
          </li>
        </ul>
      </div>

      <div
        v-hasPermi="['apartment:owner:remove']"
        class="delete"
        @click.stop="deleteOwnerManagement(ownerItem.id)"
      >
        <img src="../../../assets/icon/delete.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["ownerItem"],
  data() {
    return {};
  },
  mounted() {
    console.log();
  },
  methods: {
    goGl(value) {
      this.$router.push(`/index/member/administrator/管理员/${value}`);
    },
    goHt(value) {
      this.$router.push({
        path: "constractInformation",
        query: {
          name: value,
        },
      });
    },
    goRc(value) {
      this.$router.push({
        path: "personnelInformation",
        query: {
          name: value,
        },
      });
    },
    deleteOwnerManagement(id) {
      this.$confirm("确定删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(2222222222);
          // 子组件里面调用父组件的方法通过this.$parent
          // this.$parent.
          debugger;
          this.$http
            .post("/api/ownerManage/deleteOwnerManage", {
              deptIds: [this.ownerItem.id],
            })
            .then((res) => {
              this.$message.success(res.data.message);
              this.$parent.$parent.$parent.getAll();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped="scoped">
.card {
  position: relative;
  /* border: 1px solid lightgray; */
  padding: 20px;
  border-radius: 10px;
  margin: 15px 0;
}

.card section {
  display: flex;
  justify-content: space-between;
}

.card .left img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.card .right p {
  margin: 5px 0;
}

.card .right p:nth-of-type(2) span:nth-of-type(1) {
  /* 	font-size: 20px; */
  color: #6f6f6f;
}

.card .right p:nth-of-type(2) span:nth-of-type(2) {
  color: #373737;
  font-size: 0.875rem;
  color: #818181;
}

.card .right p:nth-of-type(1) {
  color: #6f6f6f;
  font-size: 20px;
  height: 30px;
  font-weight: bold;
}

.card .right p:nth-of-type(2) {
  height: 25px;
  line-height: 25px;
}

.card .bottom {
  display: flex;
  justify-content: space-between;
  margin: 15px 0 10px;
}

.delete {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 5px;
  left: 5px;
  display: inline-block;
}

.delete img {
  width: 100%;
}

.bottom ul {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  border-top: 1px solid #e2e2e2;
  padding-top: 5px;
}

.bottom ul li {
  text-align: center;
  color: #8b8b8b;
}

.bottom ul li p:nth-of-type(1) {
  font-weight: bold;
  font-size: 24px;
  margin: 5px 0;
}

.bottom ul li p:nth-of-type(2) {
  font-size: small;
}

.bottom ul li:nth-of-type(1) p:nth-of-type(1) {
  color: #5ccfee;
}
</style>
